<div [jsonSchema]="productSchema"></div>
<app-sub-nav
  *ngIf="screenSize < SCREEN_SIZE.DESKTOP_UP"
  [ngClass]="ListingCategory[currentShownListingType]"
  (viewModeClick)="onViewModeClick()"
  (saveSearchClick)="onSaveSearchClick()"
  (filterClick)="onFilterClick()"
  [activeViewMode]="activeViewMode"
  [currentShownListingType]="currentShownListingType"
></app-sub-nav>
<div class="extra-nav has-pos-abs has-flex-align-center" [ngClass]="ListingCategory[currentShownListingType]">

  <ng-container *ngIf="screenSize !== SCREEN_SIZE.MOBILE_ONLY">
    <div class="full-search flex-one hide-on-desktop-down">
      <app-search-bar *ngIf="screenSize >= SCREEN_SIZE.DESKTOP_UP" ></app-search-bar>
    </div>
    <app-filters-desktop class="filters" *ngIf="currentShownListingType !== ListingCategory.COMMERCIAL"></app-filters-desktop>
    <app-filters-commercial-desktop class="filters" *ngIf="currentShownListingType === ListingCategory.COMMERCIAL"></app-filters-commercial-desktop>
  </ng-container>
  <div class="is-flex" style="flex: 1.5; justify-content: flex-end">
    <div id="homePage-button-saveSearch" role="button" tabindex="0" class="save-search is-flex is-flex-column has-flex-content-center has-flex-align-center" (click)="showSaveSearchModal = true" (keydown.enter)="showSaveSearchModal = true">
      <div>
        <svg ngNonBindable width="22px" height="22px" viewBox="0 0 29 28" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g transform="translate(-1329 -179)" fill="none" fill-rule="evenodd">
            <g transform="translate(1329 179)">
              <g transform="translate(.5 .32891)">
                <path d="m8.787 18.687c0.22863 0 0.45727 0.082803 0.63647 0.25026l6.0495 5.6664v-16.506c0-0.51535-0.12977-0.88426-0.39548-1.1277-0.43873-0.40536-1.2173-0.43873-1.4769-0.41649-0.024717 0.0018538-0.055614 0.0037076-0.080331 0.0037076h-10.01c-0.42019 0-0.73534 0.11061-0.95161 0.33863-0.41401 0.43379-0.46345 1.2377-0.45109 1.4299v16.278l6.0495-5.6664c0.1792-0.16746 0.40166-0.25026 0.63029-0.25026zm-6.6798 8.0553h0.0061793-0.0061793zm14.293 0.9269c-0.23481 0-0.46345-0.08651-0.63647-0.25088l-6.9764-6.5346-6.9703 6.5346c-0.27189 0.25335-0.66737 0.32194-1.0072 0.17426-0.33368-0.14707-0.55614-0.48137-0.55614-0.85027v-18.37c-0.0061793-0.12791-0.055614-1.6863 0.95779-2.7535 0.57468-0.59878 1.3656-0.91516 2.2987-0.91516h9.9734c0.3275-0.024717 1.7858-0.066119 2.8363 0.88982 0.45727 0.4171 1.0072 1.1901 1.0072 2.5045v18.644c0 0.3689-0.22246 0.70321-0.56232 0.85027-0.11741 0.051906-0.24099 0.076624-0.36458 0.076624z" fill="#004E9B"/>
                <circle cx="15.12" cy="10" r="9.52" fill="#fff"/>
                <circle cx="15.68" cy="10.56" r="6.72" fill="#fff"/>
                <path transform="translate(18.297 11.477) scale(-1 1) translate(-18.297 -11.477)" d="m20.201 15.901c-1.7334 0-3.3057-0.69543-4.455-1.8249-0.0015686 0-0.0020915-0.0052288-0.0036601-0.0052288-0.0026144 0-0.0062746-0.0052289-0.008889-0.0052289-1.1713-1.1556-1.8996-2.7608-1.8996-4.5282 0-3.5138 2.8565-6.3687 6.3671-6.3687 3.5106 0 6.3671 2.8549 6.3671 6.3687 0 3.5085-2.8565 6.3635-6.3671 6.3635zm0-14.301c-4.3755 0-7.9358 3.5608-7.9358 7.9373 0 1.9242 0.69073 3.6915 1.8353 5.0667l-5.4124 5.4118c-0.30641 0.3085-0.30641 0.80001 0 1.1085 0.1532 0.15164 0.35399 0.23007 0.55478 0.23007 0.20079 0 0.40105-0.078432 0.55425-0.23007l5.4218-5.4223c1.3632 1.1033 3.096 1.7673 4.982 1.7673 4.376 0 7.9358-3.5608 7.9358-7.9321 0-4.3765-3.5598-7.9373-7.9358-7.9373z" fill="#004E9B"/>
              </g>
            </g>
          </g>
        </svg>
      </div>
      <span translate="home.save-search"></span>
    </div>
    <div id="homePage-button-view" role="button" tabindex="0" class="expand-gallery is-flex is-flex-column has-flex-content-center has-flex-align-center" (click)="onViewModeClick(false)" (keydown.enter)="onViewModeClick(false)">
      <svg version="1.1" width="22px" height="22px" viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg" *ngIf="activeViewMode === ViewModes.MAP">
        <g fill="none" fill-rule="evenodd">
          <g transform="translate(-1625 -182)" fill="#004E9B">
            <g transform="translate(1623.5 180.44)">
              <g transform="translate(2.2 2.2)">
                <rect width="4.4" height="4.4"/>
                <rect y="8.8" width="4.4" height="4.4" />
                <rect y="17.6" width="4.4" height="4.4" />
                <rect x="8.8" width="4.4" height="4.4" />
                <rect x="8.8" y="8.8" width="4.4" height="4.4" />
                <rect x="8.8" y="17.6" width="4.4" height="4.4" />
                <rect x="17.6" width="4.4" height="4.4" />
                <rect x="17.6" y="8.8" width="4.4" height="4.4" />
                <rect x="17.6" y="17.6" width="4.4" height="4.4" />
              </g>
            </g>
          </g>
        </g>
      </svg>
      <svg class="view-map" ngNonBindable version="1.1" width="31px" height="22px" viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" *ngIf="activeViewMode === ViewModes.GALLERY">
        <defs>
          <polygon id="a" points="4.7524 15.215 25.812 15.215 29.862 28.175 0.70242 28.175"/>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <g transform="translate(-1820 -177)">
            <g transform="translate(1819.6 176.99)">
              <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#a"/>
              <path d="m5.4876 16.215l-3.425 10.96h26.44l-3.425-10.96h-19.59z" stroke="#004E9B" stroke-width="2"/>
              <g transform="translate(6.3824 .48414)" fill="#fff">
                <path d="m9.0602 22.311c5.6205-6.1135 8.4308-10.722 8.4308-13.826 0-4.6562-3.7746-8.4308-8.4308-8.4308-4.6562 0-8.4308 3.7746-8.4308 8.4308 0 3.1041 2.8103 7.7129 8.4308 13.826z"/>
                <path d="m9.0602 20.551c4.86-5.2863 7.29-9.2715 7.29-11.956 0-4.0262-3.2638-7.29-7.29-7.29-4.0262 0-7.29 3.2638-7.29 7.29 0 2.6841 2.43 6.6693 7.29 11.956z" stroke="#004E9B" stroke-width="2"/>
                <circle cx="9.0602" cy="8.1081" r="2.916" stroke="#004E9B" stroke-width="2"/>
              </g>
            </g>
          </g>
        </g>
      </svg>
      <span *ngIf="activeViewMode === ViewModes.MAP" translate="gallery.list-view"></span>
      <span *ngIf="activeViewMode === ViewModes.GALLERY" translate="gallery.map-view"></span>
    </div>
  </div>
</div>
<div class="content-wrapper flex-one">
  <app-google-map *ngIf="mapEnabled"
    [class.hidden]="activeViewMode === ViewModes.GALLERY"
    [setListingData]="listingData"
    [topHeightOffset]="topHeightOffset"
    [isDoneFetchingListings]="isDoneFetchingListings"
    (listingsPreviewed)="announceItemClicked($event)"
    (pinClicked)="onPinsClicked($event)"
    [personaType]="personaType"
    style="z-index: 0;"
  >
    <app-panel-message *ngIf="shouldShowSavedSearchModal">
      <h4 translate="panel-message.already-saved-search"></h4>
      <span class="close-ic has-pos-abs" (click)="shouldShowSavedSearchModal=!shouldShowSavedSearchModal">
        <i class="material-icons">close</i>
      </span>
      <a href="#" (click)="goToSavedSearches($event)" translate="panel-message.view-saved-searches"></a>
    </app-panel-message>
  </app-google-map>

  <app-listing-gallery-view class="gallery-view"
    [class.hidden]="(screenSize < SCREEN_SIZE.TABLET_LANDSCAPE_UP && activeViewMode !== ViewModes.GALLERY) || (screenSize >= SCREEN_SIZE.TABLET_LANDSCAPE_UP)"
    [toggleListingGallery]="activeViewMode === ViewModes.GALLERY"
    [city]="city"
    [province]="province"
    [selectedClusterListings]="previewedListings">
    <h1 class="text-center">{{h1Text}}</h1>
  </app-listing-gallery-view>

  <app-gallery-view-desktop class="is-flex is-flex-column"
    *ngIf="screenSize >= SCREEN_SIZE.TABLET_LANDSCAPE_UP"
    [showSpecificListings]="mapEnabled ? [] : previewedListings"
    [isDoneFetchingListings]="isDoneFetchingListings"
    [showRelatedOffice]="activeViewMode === ViewModes.GALLERY"
    [listingData]="sideGalleryPins"
    [highlightListing]="highlightedListing"
    [class.full-width]="activeViewMode === ViewModes.GALLERY"
    [startingPageNumber]="startingPageNumber">
    <h1 class="text-center">{{h1Text}}</h1>
    <app-cms-links *ngIf="activeViewMode === ViewModes.MAP" [links]="footerLinks" [title]="footerTitle"></app-cms-links>
    <app-footer *ngIf="activeViewMode === ViewModes.MAP" [shouldShowMobileVersion]="true" [provinces]="provinces"
    [screenSize]="screenSize" [currentShownListingType]="currentShownListingType"></app-footer>
  </app-gallery-view-desktop>

  <app-notifications [isBottomNotification]="true" [notificationLifeSpan]="1500"></app-notifications>

  <app-modal class="hide-on-desktop-down" [shouldShowModal]="showSaveSearchModal" (closeModal)="hideSearchPopup()" [allowOutsideClickToClose]="false" [templateRef]="saveSearchRef">
  </app-modal>
  <ng-template #saveSearchRef>
    <div class="top-level modal-header">
      <h3 class="text-center header-save-search" translate="home.save-search"></h3>
    </div>
    <app-save-search (closed)="hideSearchPopup()"></app-save-search>
  </ng-template>
  <app-notification-popup-modal 
    *ngIf="showNoSavedSearchFound" 
    (onClose)="showNoSavedSearchFound = false" 
    [title]="'no-saved-search.title' | translate" 
    [messageText]="'no-saved-search.text' | translate">
  </app-notification-popup-modal>
</div>

